module.exports = "<template>\n    <input type=\"week\" value.bind=\"field.value\">\n</template>\n";